import CampaignsHome from "@/modules/campaigns/views/CampaignsOverview.vue";
import CampaignsStart from '@/modules/campaigns/views/CampaignsCreate.vue';
import CampaignsEditor from "@/modules/campaigns/views/CampaignsEditor.vue";
import CampaignsSummary from '@/modules/campaigns/views/CampaignsSummary.vue';
import QuickGuide from '@/modules/campaigns/views/CampaignsQuickGuide.vue';


export const CampaignsRoutes = [
    {
        path: '/campaigns/',
        component: CampaignsHome,
    },
    {
        path: '/campaigns/create',
        component: CampaignsStart,
    },
    {
        path: '/campaigns/edit',
        component: CampaignsEditor,
    },
    {
        path: '/campaigns/summary',
        component: CampaignsSummary,
    },
    {
        path: '/campaigns/quickguide',
        component: QuickGuide,
    }
];
